/**
 * Sets a cookie.
 * @param {string} name - Name for the cookie.
 * @param {string} value - Value for the cookie.
 * @param {number} days - Number of days until the cookie should expire.
 */
function setCookie(name, value, days) {
  let expires = '';

  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = `; expires=${date.toUTCString()}`;
  }

  document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}${expires}; path=/; SameSite=None; Secure`;
}

/**
 * Gets the value of a cookie (if it exists).
 * @param {string} name - Name of the cookie.
 * @returns {?string}
 */
function getCookie(name) {
  const cookieString = `; ${document.cookie}`;
  const cookies = cookieString.split(`; ${name}=`);

  if (cookies.length === 2) {
    return cookies.pop().split(';').shift();
  }

  return null;
}

/* Milton: show the pop-up only once per browser (remembered in cookie + localStorage) */
const MLT_POPUP_SEEN_KEY = 'mlt-popup-seen';
const MLT_POPUP_DAYS = 365;

function mltPopupSeen() {
  try {
    if (localStorage.getItem(MLT_POPUP_SEEN_KEY)) return true;
  } catch (e) { /* storage unavailable */ }
  return getCookie(MLT_POPUP_SEEN_KEY) !== null;
}

function mltMarkPopupSeen() {
  try {
    localStorage.setItem(MLT_POPUP_SEEN_KEY, String(Date.now()));
  } catch (e) { /* storage unavailable */ }
  setCookie(MLT_POPUP_SEEN_KEY, true, MLT_POPUP_DAYS);
}

/* global Modal */

if (!customElements.get('pop-up')) {
  customElements.whenDefined('modal-dialog').then(() => {
    class PopUp extends Modal {
      constructor() {
        super();
        this.cookie = `${this.id}-dismissed`;

        if (Shopify.designMode) {
          document.addEventListener('shopify:section:select', (evt) => {
            if (evt.target === this.closest('.shopify-section')) this.open();
          });

          document.addEventListener('shopify:section:deselect', this.close.bind(this));
        } else if (!getCookie(this.cookie) && !mltPopupSeen() && (this.dataset.showOnMobile === 'true'
          || theme.mediaMatches.md)) {
          if (this.querySelector('.alert')) {
            this.open();
          } else if (this.dataset.trigger === 'delay') {
            setTimeout(() => this.open(), Number(this.dataset.delay) * 1000);
          } else if (this.dataset.trigger === 'exit' && theme.mediaMatches.md) {
            this.mouseLeaveHandler = this.mouseLeaveHandler || this.handleMouseLeave.bind(this);
            document.body.addEventListener('mouseleave', this.mouseLeaveHandler);
          }
        }
      }

      /**
       * Triggers when the web component is removed from the DOM
       */
      disconnectedCallback() {
        if (this.mouseLeaveHandler) {
          document.body.removeEventListener('mouseleave', this.mouseLeaveHandler);
        }
      }

      /**
       * Handles 'mouseleave' events on the body.
       * @param {object} evt - Event object.
       */
      handleMouseLeave(evt) {
        if (evt.clientY < 0 && !getCookie(this.cookie) && !mltPopupSeen()) this.open();
      }

      /**
       * Opens the pop-up and remembers that it has been shown (Milton: once only).
       */
      open(...args) {
        super.open(...args);
        if (!Shopify.designMode) mltMarkPopupSeen();
      }

      /**
       * Handles 'close' events on the modal.
       */
      close() {
        super.close();
        if (!Shopify.designMode) mltMarkPopupSeen();
      }
    }

    customElements.define('pop-up', PopUp);
  });
}
